export default state => {
  return {
    authenticated: state.auth.authenticated,
    userType: state.auth.userType,
    userId: state.auth.userId,
    username: state.auth.username,
  };
};



// WEBPACK FOOTER //
// ./src/selectors/authSelector.js